import AlertConnection from './AlertConnection';

export default AlertConnection;
